import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import get from "lodash/get"
import {
  READ_STATUS_MODEL_LIST,
  READ_STATUS_MODEL_LIST_SUCCEEDED,
  READ_STATUS_MODEL_LIST_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {
  list: [],
  status: INITIAL,
}

export default function validateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Обновление статуса на календаре
    case READ_STATUS_MODEL_LIST:
      return {
        ...state,
        status: PENDING,
      }
    // Обновление статуса в форме события
    case READ_STATUS_MODEL_LIST_SUCCEEDED:
      return {
        ...state,
        list: get(action, `config.data`),
        status: COMPLETED,
      }
    case READ_STATUS_MODEL_LIST_FAILED:
      return {
        ...state,
        status: FAILED,
      }
    default:
      return state
  }
}
